import { designToken, quickProperty } from '../component-tokens';
import { sizeAttributes } from './utils';
export const iconBadgeData = {
    name: 'icon-badge',
    reactImports: 'IconBadge',
    attributes: Object.assign(Object.assign({}, sizeAttributes('2.25rem')), { 'border-radius': designToken('radius-small'), '--goto-icon-size': quickProperty('1.5rem'), '--goto-icon-color': designToken('icon-color-secondary'), 'background-color': designToken('surface-color-secondary'), display: quickProperty('grid'), 'place-items': quickProperty('center') }),
    variants: [
        {
            name: 'pdf',
            attributes: {
                '--goto-icon-color': designToken('badge-color-customer'),
                'background-color': designToken('surface-color-danger-secondary'),
            },
        },
        {
            name: 'document',
            attributes: {
                '--goto-icon-color': designToken('badge-color-message'),
                'background-color': designToken('surface-color-brand-secondary'),
            },
        },
        {
            name: 'spreadsheet',
            attributes: {
                '--goto-icon-color': designToken('badge-color-voice'),
                'background-color': designToken('surface-color-success-secondary'),
            },
        },
        {
            name: 'partner',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-custom'),
            },
        },
        {
            name: 'audio',
            attributes: {
                '--goto-icon-color': designToken('badge-color-audio'),
                'background-color': designToken('surface-color-warning-secondary'),
            },
        },
        {
            name: 'video',
            attributes: {
                '--goto-icon-color': designToken('badge-color-gotoresolve'),
                'background-color': designToken('surface-color-utility-purple'),
            },
        },
        {
            name: 'sketch',
            attributes: {
                '--goto-icon-color': designToken('badge-color-meeting'),
                'background-color': designToken('surface-color-utility-orange'),
            },
        },
        {
            name: 'voice',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-voice'),
            },
        },
        {
            name: 'meeting',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-meeting'),
            },
        },
        {
            name: 'message',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-message'),
            },
        },
        {
            name: 'assist',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-assist'),
            },
        },
        {
            name: 'assistmobile',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-assist'),
            },
        },
        {
            name: 'training',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-training'),
            },
        },
        {
            name: 'webinar',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-webinar'),
            },
        },
        {
            name: 'customer',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-customer'),
            },
        },
        {
            name: 'custom',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-custom'),
            },
        },
        {
            name: 'gotoresolve',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-gotoresolve'),
            },
        },
        {
            name: 'gotoresolveremotesupport',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvehelpdesk',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvemobile',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvecamerashare',
            attributes: {
                '--goto-icon-color': designToken('icon-color-inverted'),
                'background-color': designToken('badge-color-gotoresolve'),
            },
        },
    ],
    states: [
        {
            name: 'disabled',
            attributes: {
                'background-color': designToken('badge-color-disabled'),
                color: designToken('type-color-disabled'),
                cursor: quickProperty('default'),
                '--goto-icon-color': designToken('icon-color-disabled'),
            },
        },
    ],
    sizes: [
        {
            name: 'small',
            attributes: Object.assign(Object.assign({}, sizeAttributes('1.5rem')), { '--goto-icon-size': quickProperty('1rem') }),
        },
        {
            name: 'large',
            attributes: Object.assign(Object.assign({}, sizeAttributes('3rem')), { '--goto-icon-size': quickProperty('2rem'), 'border-radius': designToken('radius-medium') }),
        },
        {
            name: 'xlarge',
            attributes: Object.assign(Object.assign({}, sizeAttributes('3rem')), { '--goto-icon-size': quickProperty('2rem'), 'border-radius': designToken('radius-medium') }),
        },
    ],
};
export const iconBadgeTypes = [
    'audio',
    'calendar',
    'code',
    'contact',
    'custom',
    'document',
    'font',
    'image',
    'link',
    'pdf',
    'presentation',
    'sketch',
    'spreadsheet',
    'vector',
    'video',
    'zip',
    'call',
    'partner',
    'messaging',
    'meeting',
    'highlighter',
    'training',
    'assist',
    'assistmobile',
    'room',
    'webinar',
    'gotoresolve',
    'gotoresolveremotesupport',
    'gotoresolvehelpdesk',
    'gotoresolvemobile',
    'gotoresolvecamerashare',
];
/**
 * @deprecated 'large' will be deprecated in the next major update. Use 'xlarge' instead.
 */
export const iconBadgeSizes = ['small', 'medium', 'large', 'xlarge'];
